var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.societyLogoUrl)?_c('div',{staticClass:"clearfix my-2"},[_c('b-img',{staticStyle:{"max-height":"100px","width":"auto"},attrs:{"left":"","src":_vm.societyLogoUrl}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }